import React from 'react';
import { styled } from '@mui/material/styles';
import Tab, { TabProps } from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
interface TwTabProps extends TabProps {
  label: string;
}

const TwLoadDetailTabsGroup = styled(Tabs)({
  textTransform: 'none',
  marginBottom: '20px',

  '& .MuiTabs-indicator': {
    height: 0
  },
  '& .MuiTabs-flexContainer': {
    flexWrap: 'wrap'
  },
  '& .MuiTab-root': {
    minWidth: 'auto', // Allow tabs to be as small as their content
    flex: '0 1 auto' // Allow tabs to shrink but not grow
  }
});

const TwLoadDetailTab = styled((props: TwTabProps) => <Tab disableRipple {...props} />)(() => ({
  textTransform: 'none',
  fontStyle: 'normal',
  fontWeight: 600,
  fontFamily: 'Poppins, sans-serif',
  fontSize: '14px',
  height: '50px',
  minHeight: '50px',
  color: '#7E858E',

  '&.Mui-selected': {
    color: '#1F2937',
    border: '1px solid #E5E7EB',
    borderRadius: '6px'
  }
}));

export { TwLoadDetailTabsGroup, TwLoadDetailTab };
